import React from 'react';
import { motion } from 'framer-motion';
import { RefreshCw } from 'lucide-react';
import { SlideWrapper } from '../ui/SlideWrapper';
import { processSteps } from '../../data/processSteps';
import { EASE_OUT } from '../../utils/motion';
export function OverviewSlide() {
  const rows = [processSteps.slice(0, 4), processSteps.slice(4, 8)];
  return <SlideWrapper data-id="element-300" data-mp="3l49moipg3nbw">
      <div className="pt-12 pb-12" data-id="element-301" data-mp="3l4rtuadnblyl">
        <motion.h2 className="text-4xl xl:text-5xl font-bold text-primary mb-4" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE_OUT,
        delay: 0.1
      }} data-id="element-302" data-mp="3p5bliyfg9xdc">
          Unser Entwicklungsprozess
        </motion.h2>
        <motion.p className="text-lg xl:text-xl text-text-secondary mb-14 max-w-2xl" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE_OUT,
        delay: 0.15
      }} data-id="element-303" data-mp="7vdmqok1wisd">
          Acht Schritte – transparent, in kleinen Etappen und immer gemeinsam
          mit Ihnen.
        </motion.p>

        <div className="space-y-12" data-id="element-304" data-mp="26bqelngkouwy">
          {rows.map((row, ri) => <div key={ri} className="relative" data-id="element-305" data-mp="26afdjveii19j" data-mpi={ri}>
              <div className="absolute top-5 left-5 right-5 h-0.5 bg-gray-200 hidden md:block" data-id="element-306" data-mp="21e6xmfshq41b">
                <motion.div className="h-full bg-accent" initial={{
              width: 0
            }} animate={{
              width: '100%'
            }} transition={{
              duration: 1.2,
              ease: 'linear',
              delay: 0.3 + ri * 1.2
            }} data-id="element-307" data-mp="1wf3tcxkc41ue" />
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-308" data-mp="2k2vgkw7exzag">
                {row.map((step, i) => <motion.div key={step.number} className="relative" initial={{
              opacity: 0,
              y: 16
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.3,
              ease: EASE_OUT,
              delay: 0.3 + ri * 1.2 + i * 0.3
            }} data-id="element-309" data-mp="2g10919yw2po8" data-mpi={i}>
                    <span className="w-10 h-10 rounded-full bg-white border-2 border-accent text-primary font-bold flex items-center justify-center" data-id="element-310" data-mp="1b2mv3kf4tlrc">
                      {step.number}
                    </span>
                    <h3 className="text-lg xl:text-xl font-bold text-primary mt-4 mb-1" data-id="element-311" data-mp="1171xdyh3j7ne">
                      {step.title}
                    </h3>
                    <p className="text-text-secondary" data-id="element-312" data-mp="s4ivbgl4wz27">{step.short}</p>
                    {step.repeatsPerSprint && <span className="mt-2 inline-flex items-center gap-1.5 text-xs font-semibold text-primary" data-id="element-313" data-mp="dgpe5rgehohi">
                        <RefreshCw className="w-3.5 h-3.5 text-accent-dark" data-id="element-314" data-mp="ieqysgth5vv3" />
                        wiederholt sich je Sprint
                      </span>}
                  </motion.div>)}
              </div>
            </div>)}
        </div>
      </div>
    </SlideWrapper>;
}